// Shared brand logo — used in login / forgot / reset password pages.
// 2026-05-16: PNG (platinum 配色) instead of inline SVG so it survives
// dark / light background changes. Extracted out of LoginPage so the
// auth-flow pages can reuse without inlining the same JSX in each.

export function BrandLogo({ className }: { className?: string }) {
  return <img src="/tristone-on-dark.svg" alt="叁石資本" className={className} draggable={false} />;
}
